<div 
    [class.hidden]="isOut" 
    [@slideInLeft]="isIn && left" 
    [@slideInRight]="isIn && right" 
    [@slideOutLeft]="isOut && left"
    [@slideOutRight]="isOut && right"> 
  <ng-content></ng-content>
</div>